import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import { Breadcrumbs } from './Breadcrumbs'
import { CommandPalette } from './CommandPalette'

/**
 * Оболочка консоли.
 *
 * Десктоп-first: плотная многоколоночная раскладка, боковая навигация,
 * хлебные крошки, командная палитра. На узком экране sidebar
 * сворачивается в выдвижную панель — но это по-прежнему консоль,
 * а не водительский интерфейс.
 */
export function ConsoleLayout() {
  const [collapsed, setCollapsed] = useState(false)
  const [navOpen, setNavOpen] = useState(false)
  const [cmdkOpen, setCmdkOpen] = useState(false)

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        setCmdkOpen((o) => !o)
      }
      if (e.key === 'Escape') {
        // Escape должен закрывать палитру независимо от того, успел ли
        // фокус попасть в её поле ввода: оно фокусируется с задержкой,
        // и быстрый Esc раньше уходил в пустоту, оставляя палитру открытой.
        setNavOpen(false)
        setCmdkOpen(false)
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  return (
    <div className={`console-shell ${collapsed ? 'is-collapsed' : ''} ${navOpen ? 'is-nav-open' : ''}`}>
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed((c) => !c)}
        onNavigate={() => setNavOpen(false)}
      />
      {navOpen && (
        <button
          type="button"
          className="console-scrim"
          aria-label="Закрыть навигацию"
          onClick={() => setNavOpen(false)}
        />
      )}
      <div className="console-body">
        <TopBar onOpenSearch={() => setCmdkOpen(true)} onOpenNav={() => setNavOpen(true)} />
        <Breadcrumbs />
        <main className="console-content">
          <Outlet />
        </main>
      </div>
      <CommandPalette open={cmdkOpen} onClose={() => setCmdkOpen(false)} />
    </div>
  )
}
